import { AxiosError } from 'axios'

import {
  getEnv,
  staging,
} from '@/utils/env'

export const getIMToken = () => {
  if (getEnv() === staging) {
    return '2ebc195aede9ecf0a4c1d0be875d2d94'
  }
  return '2ebc195aede9ecf0a4c1d0be875d2d94'
}

export interface ErrorResponse {
  message: string
  code: number
}

export function isErrorResponse(error: unknown): error is ErrorResponse {
  return typeof error === 'object'
    && error !== null
    && 'message' in error
    && typeof error.message === 'string'
}

export function isAPIErrorResponse(
  error: unknown,
): error is AxiosError<ErrorResponse> {
  return typeof error === 'object'
    && error !== null
    && 'request' in error
    && 'config' in error
    && 'response' in error
    && typeof error.response === 'object'
    && error.response !== null
    && 'data' in error.response
    && isErrorResponse(error.response.data)
}

export type CancelError = typeof cancelError

export const cancelError = new Error('Cancelled')

export const isCancel = (error: unknown): boolean => {
  if (error === cancelError) {
    return true
  }
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return error.message === 'Cancelled' || error.message === 'Rejected'
  }
  return false
}
